import { useQuery } from "@tanstack/react-query";
import { mvpApiListStores, PagedStoreSchema } from "@labeling-tools/api/atlas";

export function useAtlasStores(lebronStoreId: string | null) {
  return useQuery({
    queryKey: ["stores", lebronStoreId],
    queryFn: async () => {
      const response = await mvpApiListStores({
        query: {
          lebron_id: lebronStoreId || "",
        },
      });

      if (response.error) {
        throw new Error(`Failed to fetch product: ${response.error}`);
      }

      return response.data as PagedStoreSchema;
    },
    enabled: !!lebronStoreId,
  });
}
